import { ClockIcon } from "@phosphor-icons/react";
import { useMemo } from "react";
import Pill from "../../common/Pill/Pill";

const formattedScheduledDateString = (scheduledDate) => {
  const dueDate = new Date(scheduledDate);

  const month = dueDate.getMonth() + 1;
  const day = dueDate.getDate();

  return `Unlocks ${month}/${day}`;
};

const ScheduledPill = ({ scheduledDate }) => {
  const scheduledDateString = useMemo(
    () => (scheduledDate ? formattedScheduledDateString(scheduledDate) : "Locked until further notice"),
    [scheduledDate]
  );

  if (!scheduledDate) return null;

  return (
    <Pill
      text={scheduledDateString}
      textColor="#475467"
      backgroundColor="#EAECF0"
      leftIcon={<ClockIcon size={14} color={"#344054"} />}
      accessibilityLabel={scheduledDateString}
      accessibilityRole="text"
    />
  );
};

export default ScheduledPill;
